


const Data = [
  {
    
    projectImageURL: "https://avatars.githubusercontent.com/u/19822348?v=4",
    issueURL:"https://www.google.com",
    projectName: "Project 1",
    issueShortDesc: "One Line Description",
    issueLongDesc: "Detailed Description of the issue",
  },
  {
    projectImageURL: "https://avatars.githubusercontent.com/u/23416667?s=200&v=4",
    issueURL:"https://www.google.com",
    projectName: "Project 2",
    issueShortDesc: "One Line Description",
    issueLongDesc: "Detailed Description of the issue",
  },
  

];

export default Data;



